import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {CheckOutlined} from "@ant-design/icons";
import "../../../styles/component/user-creation-success.scss"
import {useLocation} from "react-router-dom";
import resources from "../../../resources";
import {IUser} from "../user-interfaces";

const UserCreateSuccess = () => {
    const [showSpinner, setShowSpinner] = useState<boolean>(true);
    const [showConfetti, setShowConfetti] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const {record} = (location.state ?? {}) as { record?: IUser };
    const tempResource = resources.userCreateSuccess

    function generateConfetti() {
        const confettiWrapper = document.querySelector('.confetti-wrapper');
        for (let i = 0; i < 50; i++) {
            const confetti = document.createElement('div');
            confetti.classList.add('confetti-piece');
            confetti.style.left = `${Math.random() * 100}%`;
            confetti.style.setProperty('--fall-duration', `${Math.random() * 3 + 3}s`);
            confetti.style.setProperty('--confetti-color', getRandomColor());
            confettiWrapper?.appendChild(confetti);
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setShowSpinner(false);
            setShowConfetti(true);
        }, 2500)
        if (showConfetti) {
            generateConfetti();
        }
        window.history.pushState(null, '', window.location.href);
        window.onpopstate = function (event) {
            window.history.go(1);
        };
    }, [])

    const successSpin = () => {
        return (
            <div className="success-spinner__container">
                <div className="success-spinner__circle">
                    <div className="success-spinner__check">
                        <CheckOutlined/>
                    </div>
                </div>
            </div>
        )
    }

    function handleCancelBtn() {
        navigate('/user/list')
    }

    function getRandomColor() {
        const colors = ['#ff6347', '#ffa500', '#32cd32', '#1e90ff', '#ff69b4'];
        return colors[Math.floor(Math.random() * colors.length)];
    }

    const handelGotoEmployeeCreate = () => {
        navigate('/employee/create/personal', {state: {record: record}})
    }

    return (
        <>
            {showSpinner ?
                successSpin()
                :
                <div className={'user-create-success'}>
                    <div className={'user-create-success__card'}>
                        <div className={'header'}>
                        </div>
                        <div className={'body'}>
                            <h4 style={{paddingTop: 15, fontWeight: 700, fontSize: 20}}>🎉
                                Congratulations {record?.firstName}!
                                🎉</h4>
                            <div>
                                <p>
                                    {tempResource.description1} <span
                                    style={{display: 'block', color: "blue"}}>{record?.email}</span>
                                    {tempResource.description2}</p>
                                <p>{tempResource.description3}</p>
                            </div>

                        </div>
                    </div>
                    <div className={'animation-card'}>
                        <span className={'animation-card__image'}>
                            <img
                                src={"/images/user.png"}
                                alt={"Users Icon"}
                            />
                        </span>
                        <span className={'animation-card__content'}>
                            <p>{tempResource.confirmationText}</p>
                            <button
                                className={'success-btn'}
                                onClick={() => handelGotoEmployeeCreate()}>
                                {tempResource.yesCreateEmployeeButton}
                            </button>
                            <button
                                className={'no-thanks-btn'}
                                onClick={() => {
                                    handleCancelBtn()
                                }}>
                                {tempResource.noThanksButton}
                            </button>
                        </span>
                    </div>
                </div>
            }
        </>
    );
}

export default UserCreateSuccess;